import {EventEmitter, Injectable, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListenerService {

  changeInLeftPanelData: EventEmitter<any> = new EventEmitter();
  changeInLeftPanelDataV2: EventEmitter<any> = new EventEmitter();
  changeInPlatformAPIsData: EventEmitter<any> = new EventEmitter();
  manageEntitiesUpdate: EventEmitter<any> = new EventEmitter();
  saveEntityAndExecutors: EventEmitter<any> = new EventEmitter();
  emitIPRestriction = new EventEmitter<any>();
  jobScheduled = new EventEmitter<any>();
  generateTableFromChild = new EventEmitter<any>();
  generateObjFromChild = new EventEmitter<any>();
  switchEnvironments = new EventEmitter<any>();
  notifyWorkflowBuilder: EventEmitter<any> = new EventEmitter();
  assignAPIToTask: EventEmitter<any> = new EventEmitter();


  // @Output() saveEntityAndExecutors: EventEmitter<any> = new EventEmitter();
  // private cdSource = new BehaviorSubject<number>(1);


  constructor() { }
}
